import getEnvironment from "./getEnvironment";

let contactUsClickHandler;
if (typeof window !== "undefined") {
  contactUsClickHandler =
    getEnvironment() !== "production"
      ? () =>
          window.open(
            "https://cms.uat.britishcarauctions.net/contact-us",
            "_self"
          )
      : () => window.open("https://www.bca.co.uk/contact-us", "_self");
}

export default contactUsClickHandler;
